<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
@if (viewMode === ViewModes.Grid) {
  <div
    infiniteScroll
    [infiniteScrollDistance]="5"
    [infiniteScrollThrottle]="50"
    [infiniteScrollDisabled]="isMaxProducts || isLastPage || isEmpty"
    (scrolled)="scrollPage((model?.pagination?.currentPage ?? 0) + 1)"
    >
    <div class="row">
      @for (product of model?.products; track product) {
        <cx-product-grid-item
          [product]="product"
          class="col-12 col-sm-6 col-md-4"
        ></cx-product-grid-item>
      }
    </div>
    <div
      [className]="
        !isLastPage && (model?.pagination?.currentPage ?? 0) > 0
          ? 'cx-double-btn-container grid-btn-padding'
          : 'cx-single-btn-container grid-btn-padding'
      "
      >
      @if ((isMaxProducts || isLastPage) && (model?.pagination?.currentPage ?? 0) > 0) {
        <div
          (click)="scrollToTop()"
          class="btn btn-block btn-secondary"
          >
          {{ 'productList.backToTopBtn' | cxTranslate }}
        </div>
      }
      @if (isMaxProducts && !isLastPage) {
        <div
          (click)="loadNextPage((model?.pagination?.currentPage ?? 0) + 1)"
          class="btn btn-block btn-secondary align-btn"
          >
          {{ 'productList.showMoreBtn' | cxTranslate }}
        </div>
      }
    </div>
    @if (appendProducts) {
      <div class="cx-spinner">
        <cx-spinner></cx-spinner>
      </div>
    }
  </div>
}

@if (viewMode === ViewModes.List) {
  <div
    infiniteScroll
    [infiniteScrollDistance]="3"
    [infiniteScrollThrottle]="50"
    [infiniteScrollDisabled]="isMaxProducts || isLastPage || isEmpty"
    (scrolled)="scrollPage((model?.pagination?.currentPage ?? 0) + 1)"
    >
    @for (product of model?.products; track product) {
      <cx-product-list-item [product]="product" class="cx-product-search-list"></cx-product-list-item>
    }
    <div [className]="!isLastPage && (model?.pagination?.currentPage ?? 0) > 0 ? 'cx-double-btn-container' : 'cx-single-btn-container'">
      @if ((isMaxProducts || isLastPage) && (model?.pagination?.currentPage ?? 0) > 0) {
        <div
          (click)="scrollToTop()"
          class="btn btn-block btn-secondary"
          >
          {{ 'productList.backToTopBtn' | cxTranslate }}
        </div>
      }
      @if (isMaxProducts && !isLastPage) {
        <div
          (click)="loadNextPage((model?.pagination?.currentPage ?? 0) + 1)"
          class="btn btn-block btn-secondary align-btn"
          >
          {{ 'productList.showMoreBtn' | cxTranslate }}
        </div>
      }
    </div>
    @if (appendProducts) {
      <div class="cx-spinner">
        <cx-spinner></cx-spinner>
      </div>
    }
  </div>
}
